import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'react-toastify';

import { showErrorToast } from '@hooks/showErrorToast';
import { apiClient } from '@utils';

interface HookProps {
  declarationId: string;
}

export const useSendProvidedDocuments = () => {
  const queryClient = useQueryClient();

  const mutationFn = async ({ declarationId }: HookProps) => {
    const result = await apiClient.idms.sendDocuments.mutation({ params: { declarationId } });
    if (result.status !== 200) {
      throw result.body;
    }
  };

  return useMutation({
    mutationFn,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['declaration'] });
      toast.success('Documents sent successfully!');
    },
    onError: (error) => {
      showErrorToast(error, `Error sending documents!`);
    },
  });
};
